import React from 'react'
import { Navigate } from 'react-router-dom'
import { useUserContext } from '../context/user_context'
// import {useAuth0} from '@auth0/auth0-react'


const PrivateRoute = ({ children,...rest}) => {
  const { myUser } = useUserContext()
  return myUser? children: <Navigate to='/'/>;
}
export default PrivateRoute